import { ActionIcon, Group, Select, TextInput } from "@mantine/core";
import { IconX } from "@tabler/icons-react";
import { useDebouncedValue } from "@mantine/hooks";
import { useEffect, useState } from "react";

interface LicenseFiltersProps {
	searchTerm: string;
	statusFilter: string;
	accountFilter: string;
	licenseTypeFilter: string;
	accountOptions: Array<{ value: string; label: string }>;
	licenseTypeOptions: Array<{ value: string; label: string }>;
	onSearchChange: (value: string) => void;
	onStatusFilterChange: (value: string | null) => void;
	onAccountFilterChange: (value: string | null) => void;
	onLicenseTypeFilterChange: (value: string | null) => void;
}

const STATUS_OPTIONS = [
	{ value: "active", label: "Active" },
	{ value: "inactive", label: "Inactive" },
	{ value: "initialized", label: "Initialized" },
	{ value: "revoked", label: "Revoked" },
	{ value: "expired", label: "Expired" },
	{ value: "hold", label: "Hold" },
];

function LicenseFilters({
	searchTerm,
	statusFilter,
	accountFilter,
	licenseTypeFilter,
	accountOptions,
	licenseTypeOptions,
	onSearchChange,
	onStatusFilterChange,
	onAccountFilterChange,
	onLicenseTypeFilterChange,
}: LicenseFiltersProps) {
	const [localSearchTerm, setLocalSearchTerm] = useState(searchTerm);
	const [debouncedSearchTerm] = useDebouncedValue(localSearchTerm, 500);

	useEffect(() => {
		onSearchChange(debouncedSearchTerm);
	}, [debouncedSearchTerm, onSearchChange]);

	useEffect(() => {
		setLocalSearchTerm(searchTerm);
	}, [searchTerm]);

	return (
		<Group mb="md">
			<TextInput
				placeholder="Search licenses (name, UID, client UID)..."
				value={localSearchTerm}
				onChange={(event) => setLocalSearchTerm(event.currentTarget.value)}
				style={{ flex: 1 }}
				rightSection={
					localSearchTerm ? (
						<ActionIcon
							variant="subtle"
							color="gray"
							onClick={() => setLocalSearchTerm("")}
							aria-label="Clear search">
							<IconX size={16} />
						</ActionIcon>
					) : null
				}
			/>
			<Select
				placeholder="Filter by Status"
				value={statusFilter}
				onChange={onStatusFilterChange}
				data={STATUS_OPTIONS}
				clearable
			/>
			<Select
				placeholder="Filter by Account"
				value={accountFilter}
				onChange={onAccountFilterChange}
				data={accountOptions}
				clearable
			/>
			<Select
				placeholder="Filter by Type"
				value={licenseTypeFilter}
				onChange={onLicenseTypeFilterChange}
				data={licenseTypeOptions}
				clearable
			/>
		</Group>
	);
}

export default LicenseFilters;
